<div class="distinct alignCenter chng-password">
  <div *ngIf="!pwUpdated && !isError">
    <div class="row">
      (<a class="cloneLink" target="_blank" rel="noopener noreferrer" href="https://tinyurl.com/yy73mfrq">Password
        guidelines</a> <span class="k-icon k-i-hyperlink-open"></span>)
    </div>
    <form id="chngePwForm" name="chngePwForm" #f="ngForm" novalidate (ngSubmit)="changePassword()" autocomplete="none">
      <fieldset class="align-left">
        <div>
          <ul class="listContant">
            <li class="error" id="new-re-password" *ngIf="displayError()">{{config.NotMatchingPasswords}}</li>
            <li class="error" id="same-dont-match" *ngIf="displayMatchingError()">{{config.SamePasswordMessage}}
            </li>
            <li class="error" id="last-psw-match" *ngIf="isPassUsed">{{config.ExisitingPassword}}
            </li>
          </ul>
        </div>
        <br>
        <div class="new-password">
          <label for="currentPassword">
            Current Password
            <input kendoTextBox id="currentPassword" [type]="inputType1" class="validate input-control form-control"
              #currentPassword="ngModel" name="currentPassword" maxlength="35" minlength="1" [(ngModel)]="curpassword"
              onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false" ngDefaultControl
              autocomplete="none" required>
            <span class="k-icon k-i-preview k-i-eye" id="currViewIcon" *ngIf="currentPassword.value"
              (click)="inputType1 = inputType1 === 'password' ? 'text' : 'password'"></span>
          </label>

          <label for="newPassword">
            New Password
            <input kendoTextBox id="newPassword" [type]="inputType2" class="validate input-control form-control" #nPass
              #newPassword="ngModel" name="newPassword" maxlength="35" minlength="1" [(ngModel)]="password"
              ngDefaultControl (keyup)="textChange();" (focus)="onFocus()" (blur)="onBlur(password)"
              onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false"
              autocomplete="none" required>
            <span class="k-icon k-i-preview k-i-eye" id="currViewIcon" *ngIf="newPassword.value"
              (click)="inputType2 = inputType2 === 'password' ? 'text' : 'password'"></span>
          </label>

          <div class="background-tan" id="tooltip-template" *ngIf="showRules">
            <ul class="psw-check-list">
              <li *ngIf="strength"> * Password Strength: <span class="bold" [ngClass]="passStrength">{{strength}}</span>
              </li>
              <li class="bold" [ngClass]="passCharcters"> * Use 8 to 64 characters</li>
              <li> * Password is case sensitive</li>
              <li> * Avoid using the same password for multiple sites.</li>
              <li> * Avoid using '+' special character.</li>
            </ul>
          </div>

          <label for="confirmPassword">
            Retype New Password
            <input kendoTextBox id="confirmPassword" [type]="inputType3" class="validate input-control form-control"
              #confirmPassword="ngModel" name="confirmPassword" maxlength="35" minlength="1" [(ngModel)]="repassword"
              ngDefaultControl onCopy="return false" onDrag="return false" onDrop="return false" onPaste="return false"
              autocomplete="none" required>
            <span class="k-icon k-i-preview k-i-eye" id="currViewIcon" *ngIf="confirmPassword.value"
              (click)="inputType3 = inputType3 === 'password' ? 'text' : 'password'"></span>
          </label>
        </div>
        <br />
        <div id="confirmCompletionContainer" class="completionContainer align-center">
          <button kendoButton class="btn btn-primary top-margin-5" id="btnPasswordSubmit" type="submit"
            [disabled]="disableButton() || isPassUsed"><em *ngIf="isLoading" class='fa fa-circle-o-notch fa-spin'></em>
            {{isLoading ? 'Submitting...' : 'Submit'}}</button>
        </div>
      </fieldset>
      <br />
    </form>
  </div>
</div>
